let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2BXEZ")).then(() => parcelRequire('2VSx5'));